import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user'
import dictionary from './modules/dictionary'
import taskNotice from './modules/taskNotice'
import project from './modules/project'
import enterprise from './modules/enterprise'
import bidSection from './modules/bidSection'
import person from './modules/person'
import role from './modules/role'
import organization from './modules/organization'
import orgField from './modules/orgField'
import pages from './modules/pages'
import attendanceSet from './modules/attendanceSet'
import dataAnalysis from './modules/dataAnalysis'
import monitoring from './modules/monitoring'
import contractor from './modules/contractor'
import builder from './modules/builder'
import team from './modules/team'
import contract from './modules/contract'
import attendance from './modules/attendance'
import salaryPay from './modules/salaryPay'
import division from './modules/division'
import progress from './modules/progress'
import concealedWork from './modules/concealedWork'
import billOfQuantities from './modules/billOfQuantities'
import measure from './modules/measure'
import material from './modules/material'
import safetyInput from './modules/safetyInput'
import training from './modules/training'
import onlineExam from './modules/onlineExam'
import signIn from './modules/signIn'
import manageEvaluation from './modules/manageEvaluation'
import officialCar from './modules/officialCar'
import pouringOrder from './modules/pouringOrder'
import goodsShipment from './modules/goodsShipment'
import mixingProduction from './modules/mixingProduction'
import insurance from './modules/insurance'
import maintenance from './modules/maintenance'
import waterwheelWork from './modules/waterwheelWork'
import aiworkbench from './modules/aiworkbench'
import domainBrand from './modules/domainBrand'
import device from './modules/device'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import { resolveApiBaseURL } from '@/utils/siteBrand'

Vue.use(Vuex)
const modules = {
  dictionary, // 字典表
  user, // 用户信息
  taskNotice, // 待办任务及通知公告
  project, // 工程项目机构及其所属查询
  enterprise, // 实体企业机构
  bidSection, // 项目标段机构及其所属查询
  person, // 人员相关信息
  role, // 用户角色及权限
  organization, // 组织机构
  orgField, // 机构下字段模版字典
  attendanceSet, // 考勤设置
  pages, // 系统页面
  dataAnalysis, // 数据指标分析
  monitoring, // 监控面板数据
  contractor, // 项目参建单位
  team, // 班组管理
  builder, // 项目参建人员
  contract, // 合同管理
  attendance, // 考勤统计
  salaryPay, // 薪酬统计发放
  division, // 工程划分
  progress, // 工程进度
  concealedWork, // 隐蔽工程
  billOfQuantities, // 工程量清单
  measure, // 计量结算
  material, // 物资材料
  safetyInput, // 安全投入管理
  training, // 培训教育
  onlineExam, // 在线考试
  signIn, // 签到管理
  manageEvaluation, // 管理考评
  insurance, // 保险信息
  officialCar, // 工程用车
  maintenance, // 维修保养
  device, // 物联设备
  pouringOrder, // 混凝土浇筑令
  goodsShipment, // 物料运输
  mixingProduction, // 砼拌站生产
  waterwheelWork, // 水车作业
  aiworkbench,
  domainBrand // 域名品牌配置
}
export default new Vuex.Store({
  state: {
    //baseURL: 'https://testzfapi.buildbee.cn', // 测试环境
    baseURL: resolveApiBaseURL(),
    zhbdURL: 'https://www.zhbdgps.com',
    wsUrl: 'ws://socket.buildbee.cn:8081/webSocket/',
    superAdminName: 'dpnadmin',
    uploadImage: '/static/files/image', // 上传图片
    uploadImageBase64: '/static/files/imageBase64', // 上传图片
    uploadSignature: '/static/files/signature', // 上传签名
    uploadCompareimage: '/static/face/compareimage', // 上传对比头像
    uploadFaceimage: '/static/face/image', // 上传普通头像
    uploadfile: '/static/files/file', // 上传文件
    defaultreport: '/rule/report/native/h5', // 原生报表预览
    reportImg: '/rule/report/native/show.jpg', // 原生报表图片
    token: '', // 登录token
    pageTitle: '',
    activePath: '', // 用户当前激活的页面
    titleImg: require('@/assets/img/tabletitle.png'), // 系统标题图片

    // 缓存预览文件
    fileType: '',
    bucket: [
      { value: 'trainingMaterials', bucket: 'dpn-video' },
      { value: 'preClassEducation', bucket: 'dpn-video' },
      { value: 'concealedWork', bucket: 'dpn-video' }
    ],
    pictures: {},
    files: {},
    pdf: '',
    word: '',
    excle: '',
    video: '',
    fileUploadingMap: {},
    unsavedUploadSession: {
      images: [],
      qiniu: [],
      committed: true
    },

    // 缓存报表
    reports: {},

    // 缓存二维码信息
    qcodeInfo: {},

    // 系统字典表
    dictionarys: {
      nation: [
        // 中国民族字典表
        { value: '01', label: '汉' },
        { value: '02', label: '蒙古' },
        { value: '03', label: '回' },
        { value: '04', label: '藏' },
        { value: '05', label: '维吾尔' },
        { value: '06', label: '苗' },
        { value: '07', label: '彝' },
        { value: '08', label: '壮' },
        { value: '09', label: '布依' },
        { value: '10', label: '朝鲜' },
        { value: '11', label: '满' },
        { value: '12', label: '侗' },
        { value: '13', label: '瑶' },
        { value: '14', label: '白' },
        { value: '15', label: '土家' },
        { value: '16', label: '哈尼' },
        { value: '17', label: '哈萨克' },
        { value: '18', label: '傣' },
        { value: '19', label: '黎' },
        { value: '20', label: '傈僳' },
        { value: '21', label: '佤' },
        { value: '22', label: '畲' },
        { value: '23', label: '高山' },
        { value: '24', label: '拉祜' },
        { value: '25', label: '水' },
        { value: '26', label: '东乡' },
        { value: '27', label: '纳西' },
        { value: '28', label: '景颇' },
        { value: '29', label: '柯尔克孜' },
        { value: '30', label: '土' },
        { value: '31', label: '达斡尔' },
        { value: '32', label: '仫佬' },
        { value: '33', label: '羌' },
        { value: '34', label: '布朗' },
        { value: '35', label: '撒拉' },
        { value: '36', label: '毛南' },
        { value: '37', label: '仡佬' },
        { value: '38', label: '锡伯' },
        { value: '39', label: '阿昌' },
        { value: '40', label: '普米' },
        { value: '41', label: '塔吉克' },
        { value: '42', label: '怒' },
        { value: '43', label: '乌孜别克' },
        { value: '44', label: '俄罗斯' },
        { value: '45', label: '鄂温克' },
        { value: '46', label: '德昂' },
        { value: '47', label: '保安' },
        { value: '48', label: '裕固' },
        { value: '49', label: '京' },
        { value: '50', label: '塔塔尔' },
        { value: '51', label: '独龙' },
        { value: '52', label: '鄂伦春' },
        { value: '53', label: '赫哲' },
        { value: '54', label: '门巴' },
        { value: '55', label: '珞巴' },
        { value: '56', label: '基诺' },
        { value: '57', label: '革家人' },
        { value: '58', label: '穿青人' },
        { value: '59', label: '其他' }
      ],
      sex: [
        // 性别
        { value: '0', label: '男' },
        { value: '1', label: '女', type: 'danger' }
      ],
      isTrue: [
        // 是否选项true/false
        { value: 'true', label: '是' },
        { value: 'false', label: '否', type: 'danger' }
      ],
      trueFalse: [
        // 是否选项true/false
        { value: true, label: '是' },
        { value: false, label: '否', type: 'danger' }
      ],
      isFalse: [
        // 是否选项1/0
        { value: '1', label: '是' },
        { value: '0', label: '否', type: 'danger' }
      ],
      isExit: [
        // 是否在场选项1/0
        { value: '1', label: '在场' },
        { value: '0', label: '退场', type: 'danger' }
      ],
      isEecord: [
        // 是否备案选项1/0
        { value: '1', label: '已备案' },
        { value: '0', label: '未备案', type: 'danger' }
      ],
      isExpired: [
        // 是否过期
        { value: '1', label: '已过期', type: 'danger' },
        { value: '0', label: '未过期', type: 'success' },
        { value: '-1', label: '未备案' }
      ],
      funStatus: [
        // 功能性质类状态字典，如资质状态
        { value: '1', label: '有效' },
        { value: '2', label: '注销', type: 'danger' },
        { value: '3', label: '过期', type: 'danger' },
        { value: '4', label: '降级', type: 'warning' }
      ],
      cerStatus: [
        // 证件有效性状态，如资质证书状态
        { value: '1', label: '有效' },
        { value: '2', label: '注销', type: 'danger' },
        { value: '3', label: '暂扣', type: 'warning' },
        { value: '4', label: '过期', type: 'danger' }
      ],
      userType: [
        // 用户类型字典表
        { value: 'qy', label: '实体企业用户', type: 'danger' },
        { value: 'gc', label: '工程项目用户' },
        { value: 'xm', label: '项目标段用户' },
        { value: 'lw', label: '劳务公司用户', type: 'warning' },
        { value: 'per', label: '个人用户', type: 'success' }
      ],
      checkingType: [
        // 考勤方式（组配置与打卡记录共用文案）
        { value: '电子围栏定位', label: '电子围栏定位' },
        { value: '门禁打卡', label: '门禁打卡', type: 'success' },
        { value: '考勤机打卡', label: '考勤机打卡', type: 'danger' },
        { value: 'web手动打卡', label: 'web手动打卡', type: 'warning' },
        { value: '班前教育打卡', label: '班前教育打卡', type: 'info' }
      ],
      attendanceAreaType: [
        // 考勤区域类型
        { value: 'point', label: '单点周边圆形区域范围' },
        { value: 'line', label: '多点连线两侧区域范围', type: 'warning' },
        { value: 'area', label: '多点连线封闭区域范围', type: 'danger' }
      ],
      checkingTwice: [{ value: '1', label: '每天一次' }],
      orgType: [
        // 机构类型
        { value: 'simPro', label: '项目标段' },
        { value: 'bigPro', label: '工程项目' },
        { value: 'com', label: '实体企业' },
        { value: 'laborCom', label: '劳务公司' },
        { value: 'personal', label: '个人登录' }
      ],
      personType: [
        { value: 'labor', label: '劳务人员' },
        { value: 'manager', label: '管理人员' }
      ],
      regulatoryBody: [
        // 监管主体
        { value: '1', label: '建设单位' },
        { value: '2', label: '监理单位' },
        { value: '3', label: '总承包单位' },
        { value: '4', label: '监管系统' }
      ],
      meetingType: [
        { value: '1', label: '生产调度暨安全质量例会' },
        { value: '2', label: '安全生产领导小组会议' },
        { value: '3', label: '安全生产例会' },
        { value: '4', label: '安全生产专题会' },
        { value: '5', label: '质量管控领导小组会议' },
        { value: '6', label: '质量分析会' },
        { value: '7', label: '质量管控专题会' }
      ],
      subitemLevel: [
        // 分部分项级别
        { value: 'singieProType', label: '单位工程', type: 'danger' },
        { value: 'subprojectType', label: '分部工程', type: 'warning' },
        { value: 'subitemProType', label: '分项工程' }
      ],
      projectConfig: [
        {
          value: '1',
          label: '公路工程',
          linkMark: '-',
          listSum: [
            {
              value: '100',
              listBreakdownCode: '100',
              listBreakdownName: '100章总则',
              label: '100章'
            },
            {
              value: '200',
              listBreakdownCode: '200',
              listBreakdownName: '200章 路基工程',
              label: '200章'
            },
            {
              value: '300',
              listBreakdownCode: '300',
              listBreakdownName: '300章 路面工程',
              label: '300章'
            },
            {
              value: '400',
              listBreakdownCode: '400',
              listBreakdownName: '400章 桥梁、涵洞工程',
              label: '400章'
            },
            {
              value: '500',
              listBreakdownCode: '500',
              listBreakdownName: '500章 隧道工程',
              label: '500章'
            },
            {
              value: '600',
              listBreakdownCode: '600',
              listBreakdownName: '600章 交通安全设施',
              label: '600章'
            },
            {
              value: '700',
              listBreakdownCode: '700',
              listBreakdownName: '700章 绿化及环境保护工程',
              label: '700章'
            },
            {
              value: '800',
              listBreakdownCode: '800',
              listBreakdownName: '800章 管理养护设施',
              label: '800章'
            },
            {
              value: '900',
              listBreakdownCode: '900',
              listBreakdownName: '900章 管理、养护及服务房屋',
              label: '900章'
            }
          ]
        },
        { value: '2', label: '市政公用工程' },
        { value: '3', label: '房屋建筑工程' }
      ],
      securityFundType: [
        {
          id: '0101',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '临时用电系统安全防护'
        },
        {
          id: '0102',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '洞口安全防护'
        },
        {
          id: '0103',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '临边作业安全防护'
        },
        {
          id: '0104',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '机械设备安全防护'
        },
        {
          id: '0105',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '高处作业安全防护'
        },
        {
          id: '0106',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '交叉作业安全防护'
        },
        {
          id: '0107',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '防火安全防护'
        },
        {
          id: '0108',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '防爆安全防护'
        },
        {
          id: '0109',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '防尘安全防护'
        },
        {
          id: '0110',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '防毒安全防护'
        },
        {
          id: '0110',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '防雷安全防护'
        },
        {
          id: '0112',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '防台风安全防护'
        },
        {
          id: '0113',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '防地质灾害安全防护'
        },
        {
          id: '0114',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '地下工程安全防护'
        },
        {
          id: '0115',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '有害气体监测'
        },
        {
          id: '0116',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '通风设施设备'
        },
        {
          id: '0117',
          securityFundType:
            '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
          expenseName: '临时安全防护',
          defaultGoodsType: '安全标志标牌'
        },
        {
          id: '0201',
          securityFundType:
            '配备、维护、保养应急救援器材、设备支出和应急演练支出',
          expenseName: '配备应急救援器材或设备',
          defaultGoodsType: '应急救援器材'
        },
        {
          id: '0202',
          securityFundType:
            '配备、维护、保养应急救援器材、设备支出和应急演练支出',
          expenseName: '维护应急救援器材或设备'
        },
        {
          id: '0203',
          securityFundType:
            '配备、维护、保养应急救援器材、设备支出和应急演练支出',
          expenseName: '保养应急救援器材或设备'
        },
        {
          id: '0204',
          securityFundType:
            '配备、维护、保养应急救援器材、设备支出和应急演练支出',
          expenseName: '应急演练支出'
        },
        {
          id: '0301',
          securityFundType: '开展重大危险源和事故隐患评估、监控和整改支出',
          expenseName: '重大危险源和事故隐患评估'
        },
        {
          id: '0302',
          securityFundType: '开展重大危险源和事故隐患评估、监控和整改支出',
          expenseName: '重大危险源和事故隐患监控',
          defaultGoodsType: '安全监控设备'
        },
        {
          id: '0303',
          securityFundType: '开展重大危险源和事故隐患评估、监控和整改支出',
          expenseName: '重大危险源和事故隐患整改'
        },
        {
          id: '0401',
          securityFundType:
            '安全生产检查、评价(不包括新建、改建、扩建项目安全评价)、咨询和标准化建设支出',
          expenseName: '安全生产检查'
        },
        {
          id: '0402',
          securityFundType:
            '安全生产检查、评价(不包括新建、改建、扩建项目安全评价)、咨询和标准化建设支出',
          expenseName: '安全生产评价'
        },
        {
          id: '0403',
          securityFundType:
            '安全生产检查、评价(不包括新建、改建、扩建项目安全评价)、咨询和标准化建设支出',
          expenseName: '安全生产咨询'
        },
        {
          id: '0404',
          securityFundType:
            '安全生产检查、评价(不包括新建、改建、扩建项目安全评价)、咨询和标准化建设支出',
          expenseName: '安全生产标准化建设'
        },
        {
          id: '0501',
          securityFundType: '配备和更新现场作业人员安全防护用品支出',
          expenseName: '作业人员安全防护用品',
          defaultGoodsType: '安全防护用品'
        },
        {
          id: '0601',
          securityFundType: '安全生产宣传、教育培训支出',
          expenseName: '安全生产宣传'
        },
        {
          id: '0602',
          securityFundType: '安全生产宣传、教育培训支出',
          expenseName: '安全生产教育培训'
        },
        {
          id: '0701',
          securityFundType:
            '安全生产适用的新技术、新标准、新工艺、新装备的推广应用支出',
          expenseName: '新技术推广应用'
        },
        {
          id: '0702',
          securityFundType:
            '安全生产适用的新技术、新标准、新工艺、新装备的推广应用支出',
          expenseName: '新标准推广应用'
        },
        {
          id: '0703',
          securityFundType:
            '安全生产适用的新技术、新标准、新工艺、新装备的推广应用支出',
          expenseName: '新工艺推广应用'
        },
        {
          id: '0704',
          securityFundType:
            '安全生产适用的新技术、新标准、新工艺、新装备的推广应用支出',
          expenseName: '新装备推广应用'
        },
        {
          id: '0801',
          securityFundType: '安全设施及特种设备检测检验支出',
          expenseName: '安全设施检测检验'
        },
        {
          id: '0802',
          securityFundType: '安全设施及特种设备检测检验支出',
          expenseName: '特种设备检测检验'
        },
        {
          id: '0901',
          securityFundType: '其他与安全生产直接相关的支出',
          expenseName: '其他与安全生产直接相关的支出',
          defaultGoodsType: '其他安全物资'
        }
      ], // 安全经费类型
      equipmentParams: [
        {
          value: 'electricEquipment',
          label: '用电设备',
          params: [
            { label: '功率(容量)', key: 'power', unit: 'kw' },
            { label: '相数', key: 'numberOfPhases', unit: '相' },
            { label: '功率因数', key: 'powerFactor', unit: '' },
            { label: '电压', key: 'voltage', unit: 'V' },
            { label: '暂载率', key: 'dutyCycle', unit: '%' }
          ]
        }
      ],
      listType: [
        // 清单类型
        { value: '1', label: '施工合同清单', type: 'danger' },
        { value: '2', label: '工程量复核清单' }
      ],
      measureState: [
        { value: 0, label: '审批拒绝', type: 'danger' },
        { value: 1, label: '审批通过', type: 'success' },
        { value: 2, label: '项目办审核中' },
        { value: 3, label: '总监办审核中' },
        { value: 4, label: '驻地办审核中' },
        { value: 5, label: '未申报', type: 'warning' },
        { value: 6, label: '未编制', type: 'warning' }
      ],
      checkResult: [
        { value: '0', label: '现场验收合格，不需试验抽检' },
        { value: '1', label: '现场验收合格，需要试验抽检', type: 'warning' },
        { value: '2', label: '现场验收合格，抽检有不合格', type: 'danger' },
        { value: '3', label: '现场验收及抽检均合格', type: 'success' }
      ],
      // 配置字典表
      configurefields: [
        { value: 'jobTitle', label: '岗位职务', type: 'init' },
        { value: 'eduContent', label: '教育内容', type: 'init' },
        { value: 'disease', label: '重大病史', type: 'system' },
        { value: 'business', label: '作业工种', type: 'system' },
        { value: 'goodsType', label: '物资类型', type: 'system' },
        { value: 'structureModel', label: '工程结构模型', type: 'organ' },
        { value: 'paperModel', label: '试卷模版', type: 'system' },
        { value: 'standardRates', label: '混凝超标标准', type: 'init' },
        { value: 'evaluationModule', label: '自动考评模块', type: 'init' },
        { value: 'fieldMenu', label: '机构可配字段', type: 'system' }
      ],
      trainingType: [
        { value: 'regularEducation', label: '经常性教育' },
        { value: 'specialEducation', label: '特种作业教育' },
        { value: 'jobChangeEducation', label: '转岗教育' },
        { value: 'onboardingEducation', label: '进场教育' }
      ],
      trainingMethods: [
        { value: 'onsiteTraining', label: '现场集中培训' },
        { value: 'selfLearning', label: '个人自主学习', type: 'success' }
      ],
      examineType: [
        { value: 'notExamined', label: '不予考核', type: 'danger' },
        { value: 'onlineExam', label: '在线考核', type: 'success' },
        { value: 'offlineExam', label: '线下答卷', type: 'warning' }
      ],
      answerRule: [
        { value: 'submitScore', label: '交卷判分' },
        { value: 'realTimeScore', label: '随答随判' }
      ],
      dataType: [
        { label: '建造师考试', value: '0' },
        { label: '安全法律法规', value: '1' },
        { label: '进场教育', value: '2' },
        { label: '技术交底', value: '3' },
        { label: '桥梁施工', value: '4' },
        { label: '路基施工', value: '5' },
        { label: '路面施工', value: '6' },
        { label: '隧道施工', value: '7' },
        { label: '涵洞施工', value: '8' },
        { label: '交安施工', value: '9' },
        { label: '房建施工', value: '10' },
        { label: '机电施工', value: '11' },
        { label: '高空作业', value: '12' },
        { label: '临边作业', value: '13' },
        { label: '特种作业', value: '14' },
        { label: '机械设备', value: '15' },
        { label: '车辆驾驶', value: '16' },
        { label: '电工作业', value: '17' },
        { label: '消防安全', value: '18' }
      ],
      applicableUsers: [
        { label: '所有现场人员', value: 'all' },
        { label: '技术人员', value: '0' },
        { label: '劳务人员', value: '1' },
        { label: '行政人员', value: '2' },
        { label: '安全员', value: '3' },
        { label: '测量员', value: '4' },
        { label: '管理人员', value: '5' },
        { label: '车辆驾驶员', value: '6' },
        { label: '设备操作员', value: '8' },
        { label: '特种作业人员', value: '9' }
      ],
      dataFormat: [
        {
          label: '视频',
          value: 'video',
          types: ['mp4', 'avi', 'mov', 'wmv', 'mkv', 'webm', 'm4v', '3gp'],
          url: require('@/assets/img/video.webp')
        },
        { label: '链接', value: 'link', types: [] },
        { label: '图文', value: 'article', types: [] },
        {
          label: 'word文档',
          value: 'word',
          types: ['doc', 'docx', 'txt', 'wps'],
          url: require('@/assets/img/word.webp')
        },
        {
          label: 'excle文档',
          value: 'excle',
          types: ['xls', 'xlsx', 'et'],
          url: require('@/assets/img/excle.webp')
        },
        {
          label: 'ppt文档',
          value: 'ppt',
          types: ['ppt', 'pptx', 'dps'],
          url: require('@/assets/img/ppt.webp')
        },
        {
          label: 'pdf文档',
          value: 'pdf',
          types: ['pdf'],
          url: require('@/assets/img/pdf.webp')
        },
        { label: '图片', value: 'image', types: ['jpeg', 'png', 'jpg', 'gif'] }
      ],
      access: [
        { label: '公开', value: 'public', type: 'success' },
        { label: '私有', value: 'private', type: 'danger' }
      ],
      paperType: [
        { label: '建造师考试', value: 'constructor' },
        { label: '进场教育', value: 'entering' },
        { label: '特种作业教育', value: 'special' },
        { label: '技术交底', value: 'technical' },
        { label: '其他', value: 'other' }
      ],
      questionType: [
        { label: '判断题', value: '0', score: 2 },
        { label: '单选题', value: '1', score: 2 },
        { label: '多选题', value: '2', score: 4 },
        { label: '填空题', value: '3', score: 2 },
        { label: '简答题', value: '4', score: 10 }
      ],
      difficulty: [
        { label: '简单', value: 'easy', type: 'success' },
        { label: '中等', value: 'medium' },
        { label: '困难', value: 'hard', type: 'danger' }
      ],
      paperStatus: [
        { value: '0', label: '新建' },
        { value: '1', label: '编制中' },
        { value: '2', label: '待确认', type: 'danger' },
        { value: '3', label: '已确认', type: 'success' }
      ],
      // 考评积分类型
      integralType: [
        { value: '1', label: '兑换' },
        { value: '2', label: '扣分', type: 'danger' },
        { value: '3', label: '奖分', type: 'success' }
      ],
      // 考评事件类型
      eventType: [
        { value: '1', label: '积分兑换' },
        { value: '2', label: '培训教育' },
        { value: '3', label: '班前教育' },
        { value: '4', label: '在线考试' },
        { value: '5', label: '优良表现' },
        { value: '6', label: '不良行为' }
      ],
      // 保险类型
      insuranceType: [
        { value: '1', label: '车险' },
        { value: '2', label: '工程险' },
        { value: '3', label: '人身险' }
      ],
      // 维修保养类型
      maintenanceType: [
        { value: '1', label: '保养' },
        { value: '2', label: '小修' },
        { value: '3', label: '大修' },
        { value: '4', label: '标定' },
        { value: '5', label: '检验' }
      ],
      carState: [
        { value: '1', label: '离线-从未报定位' },
        { value: '2', label: '离线-欠费' },
        { value: '3', label: '离线' },
        { value: '4', label: '离线-报警' },
        { value: '5', label: '在线-从未报定位' },
        { value: '6', label: '在线-欠费' },
        { value: '7', label: '在线-行驶' },
        { value: '8', label: '在线-行驶-报警' },
        { value: '9', label: '在线-停车-ACC关' },
        { value: '10', label: '在线-停车-ACC开' },
        { value: '11', label: '在线-停车-ACC关-报警' },
        { value: '12', label: '在线-停车-ACC开-报警' },
        { value: '13', label: '在线-无效定位' }
      ],
      carUsage: [
        {
          value: '1',
          label: '人员通勤',
          iconfont: 'icon-keche',
          type: 'danger'
        },
        { value: '2', label: '洒水养护', iconfont: 'icon-sashuiche', type: 'success' },
        { value: '3', label: '混凝土运输' },
        { value: '4', label: '土方运输', type: 'warning' },
        { value: '5', label: '起重吊装', type: 'warning' },
        { value: '6', label: '稳拌料运输', type: 'success' },
        { value: '7', label: '沥拌料运输', type: 'warning' },
        { value: '8', label: '燃油运输', type: 'danger' },
        { value: '9', label: '稳定料摊铺', type: 'success' },
        { value: '10', label: '沥青料摊铺', type: 'warning' },
        { value: '11', label: '混凝土滑膜作业' },
        { value: '12', label: '混凝土泵送作业', type: 'info' }
      ],
      rankingIcon: [
        '#icon-jinpai',
        '#icon-yinpai',
        '#icon-tongpai',
        '#icon-jiangpai1'
      ],
      shipmentType: [
        {
          value: '1',
          label: '混凝土运输',
          workName: 'pouringOrder',
          getWorkInfo: 'pouringOrder/getPouringOrderInfo',
          getWorkList: 'pouringOrder/getUnfinishedPouringOrderList',
          // 部位已拼进 workLocation（分项名(部位)），此处仅追加强度
          workInfoKeys: ['strengthGrade'],
          unit: 'm³'
        },
        {
          value: '2',
          label: '稳拌料运输',
          workName: 'pouringOrder',
          getWorkInfo: 'pouringOrder/getPouringOrderInfo',
          getWorkList: 'pouringOrder/getUnfinishedPouringOrderList',
          workInfoKeys: ['strengthGrade'],
          unit: 'm³'
        },
        {
          value: '3',
          label: '沥拌料运输',
          workName: 'pouringOrder',
          getWorkInfo: 'pouringOrder/getPouringOrderInfo',
          getWorkList: 'pouringOrder/getUnfinishedPouringOrderList',
          workInfoKeys: ['strengthGrade'],
          unit: 'm³'
        }
      ],
      shipmentStatus: [
        { value: '待装车', label: '待装车', type: 'info' },
        { value: '待发车', label: '待发车', type: 'warning' },
        { value: '运输中', label: '运输中' },
        { value: '合格签收', label: '合格签收', type: 'success' },
        { value: '不合格签收', label: '不合格签收', type: 'danger' },
        { value: '不合格待处置', label: '不合格待处置', type: 'danger' },
        { value: '已中止待处置', label: '已中止待处置', type: 'warning' }
      ],
      signingType: [
        { value: '中间签收', label: '中间签收' },
        { value: '终车签收', label: '终车签收', type: 'success' }
      ],
      questionErrors: [
        { key: 'questionType', status: '缺少题目类型' },
        { key: 'content', status: '缺少题目内容' },
        {
          key: 'knowledgeType',
          fun: (value) => {
            if (!value || !value.length) return '缺少知识点类型'
          }
        },
        {
          key: 'applicableUsers',
          fun: (value) => {
            if (!value || !value.length) return '缺少适用对象'
          }
        },
        {
          key: 'options',
          fun: (value, params) => {
            if (
              params.questionType === '单选题' ||
              params.questionType === '多选题'
            ) {
              if (!value || !value.length) {
                return '缺少题目选项'
              } else if (value[0].split('@|@').length < 2) {
                return '题目选项少于2个'
              }
            }
          }
        },
        {
          key: 'correctAnswer',
          fun: (value, params) => {
            if (!value || !value.length) {
              if (!params.answer) return '缺少题目答案'
              if (
                params.questionType === '单选题' ||
                params.questionType === '多选题'
              )
                return '题目答案不在选项中'
            } else if (
              (params.questionType === '单选题' ||
                params.questionType === '多选题') &&
              value[0].split('@|@').length !== params.answer.split('').length
            ) {
              return '题目答案与选项不符'
            } else if (
              params.questionType === '单选题' &&
              value[0].split('@|@').length > 1
            ) {
              return '单选题只能有一个正确选项'
            } else if (
              params.questionType === '多选题' &&
              value[0].split('@|@').length === 1
            ) {
              return '多选题至少有两个正确选项'
            }
          }
        }
      ]
    },

    // 各机构下字典表配置（系统字段页维护，业务按接口读取）
    orgFields: {
      standardRates: [],
      evaluationModule: []
    },

    // 面包屑组件参数
    currentTab: {}, // 当前页面tab, 属性有name和label
    currentStep: {}, // 当前操作业务, 属性有theme、label、checkFun
    historyStep: [], // 历史操作业务, 对象属性有theme、label、checkFun
    // 业务按钮跳全页时暂存面包屑，路由守卫追加而不是清空
    routeBreadcrumbKeep: null,

    pageStatus: {}, // 标记某组件的某种操作状态，以组件名为key值
    parentUids: {}, // 缓存某组件所依附的父级数据页面的数据uid
    currentUids: {}, // 缓存某组件数据uid
    loading: false,
    listLoading: false,
    listLoadingSeq: 0,
    pageLoading: false, // 页面加载缓冲
    isCollapse: false, //导航栏是否折叠
    // 列表组件参数
    queryValues: {}, // 查询组件查询参数值
    page: {}, // 列表页码
    limit: {}, // 列表行数
    maxHeight: {}, // 列表最大高度
    currentRow: {}, // 列表当前选中行
    selection: {}, // 列表勾选项
    expandRowKeys: {}, // 级联列表当前展开行
    radio: '',

    // 表单组件参数
    formValues: {}, // 表单数据值
    formError: {}, // 表单验证错误提示
    validate: {
      // 大于0的整数
      integersGreaterThan0: (rule, value, callback) => {
        const val = value + ''
        const regex = /^[1-9]\d*$/
        if (!regex.test(val)) {
          callback('请输入大于0的整数值')
        } else {
          callback()
        }
      },
      // 大于0的数值
      valuesGreaterThan0: (rule, value, callback) => {
        const val = value + ''
        const regex = /^[1-9]\d*(\.\d+)?$|^0\.\d+?$/
        if (!regex.test(val)) {
          callback('请输入大于0的数值')
        } else {
          callback()
        }
      }
    }, // 表单校验规则
    activeStep: NaN, // stepForm表单流程序号

    // 弹窗组件参数
    dialogName: '',
    dialogFormVisible: false,
    dialogTableVisible: false,

    // 图片预览
    imageVisible: false,
    srcList: [],

    // 查看二维码
    qrcodeFormVisible: false,

    // 抽屉组件参数
    drawerName: '',
    drawerTableVisible: false,
    crowdCountTip: null,
    aiWorkbenchJump: null,

    // 导入文件解析后列表数据
    filesData: [],
    // 导入文件解析处理后的待上传数据
    uploadData: [],
    // 题目导入页来源路径（面包屑返回）
    questionImportFrom: '/workbench/onlineExam',
    // 公共试题库来源路径（面包屑返回）
    publicQuestionsFrom: '/workbench/onlineExam',
    // 返回在线考试时恢复的 Tab（如题库管理）
    onlineExamEntryTab: '',

    // 数据加工推送
    pushData: [],
    pushDataInfo: [],
    pushResult: [],

    // 日历组件参数
    isSelectedDay: new Date(),

    // 页面内导航组件参数
    navMenus: [], // 导航菜单数据
    activeNav: '', // 当前激活菜单项

    // 缓存地图中组件参数
    mapOptions: {
      resizeEnable: true,
      zoom: 15,
      center: [116.39773, 39.904228],
      weatherCity: '朝阳区'
    },
    address: '北京市天安门广场',
    meteorology: {},
    weatherIcon: [
      { icon: 'icon-taiyang', weather: '晴' },
      { icon: 'icon-yin', weather: '阴' },
      { icon: 'icon-duoyun', weather: '多云' },
      { icon: 'icon-xue', weather: '雪' },
      { icon: 'icon-baoyudaodabaoyu', weather: '雨' },
      { icon: 'icon-wu', weather: '雾' },
      { icon: 'icon-wumai-zhongdu', weather: '雾霾' }
    ],
    mapStyles: {
      polarNightBlue: 'amap://styles/6cc1077d883198d6f20fa0ba48ed16d7',
      darkBlue: 'amap://styles/f386024a54813f56cfca33d7ba824bf1'
    },
    markers: [],
    iconMarkers: [],
    circles: [],
    polylines: [],
    polygons: [],
    texts: [],
    infoWindow: null,
    markerCluster: []
  },
  getters,
  mutations,
  actions,
  modules,
  //配置vuex-persistedstate
  plugins: [
    createPersistedState({
      //配置将vuex的状态储存到sessionStorage中（默认储存到localStorage中）
      key: 'my-app',
      storage: window.sessionStorage,
      reducer: (state) => {
        var newState = {}
        for (const key in modules) {
          if (Object.hasOwnProperty.call(modules, key)) {
            const stateData = state[key]
            newState[key] = stateData
          }
        }
        return newState
      }
    })
  ]
})
